import { render, staticRenderFns } from "./choose-apps.vue?vue&type=template&id=5b771fd4"
import script from "./choose-apps.vue?vue&type=script&lang=js"
export * from "./choose-apps.vue?vue&type=script&lang=js"
import style0 from "./choose-apps.vue?vue&type=style&index=0&id=5b771fd4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports